import { gql } from "@apollo/client";

export const LOGISTICS_HEXNODE_DEVICE = gql`
  fragment LogisticsHexnodeDevice on LogisticsHexnodeDevice {
    state
    deviceId
    url
    enrollmentStatus
    active
    lastSeenAt
    syncedAt
    stale
  }
`;

export const LOGISTICS_WORKSPACE_ONE_APP = gql`
  fragment LogisticsWorkspaceOneApp on LogisticsWorkspaceOneApp {
    bundleId
    appUuid
    installedVersion
    assignedVersion
    installedStatus
    assignmentStatus
    lastReportedAt
  }
`;

export const LOGISTICS_WORKSPACE_ONE_DEVICE = gql`
  ${LOGISTICS_WORKSPACE_ONE_APP}
  fragment LogisticsWorkspaceOneDevice on LogisticsWorkspaceOneDevice {
    deviceId
    deviceUuid
    imei
    serialNumber
    name
    model
    operatingSystem
    organizationGroupName
    enrollmentStatus
    complianceStatus
    lastSeenAt
    url
    apps {
      ...LogisticsWorkspaceOneApp
    }
  }
`;

export const LOGISTICS_WORKSPACE_ONE_MATCH = gql`
  ${LOGISTICS_WORKSPACE_ONE_DEVICE}
  fragment LogisticsWorkspaceOneMatch on LogisticsWorkspaceOneMatch {
    state
    syncedAt
    stale
    device {
      ...LogisticsWorkspaceOneDevice
    }
  }
`;

export const SALESFORCE_REPORT_SECTION = gql`
  fragment SalesforceReportSection on SalesforceReportSection {
    reportId
    type
    format
    source
    dateRange {
      field
      relative
      lastDays
      from
      to
    }
    filters {
      field
      operator
      values
    }
    filterLogic
    linkedFilters {
      field
      operator
      values
    }
    down {
      field
      granularity
      descending
      link {
        kind
        object
      }
    }
    across {
      field
      granularity
      descending
      link {
        kind
        object
      }
    }
    summaries {
      aggregate
      field
      formula
    }
    columns {
      field
      type
      link {
        kind
        object
      }
    }
    showSubtotals
    showGrandTotal
    groups {
      down {
        value
        label
      }
      across {
        value
        label
      }
      count
      values
    }
    rows {
      down {
        value
        label
      }
      values
      links
    }
    hasMoreRows
    rowLimit
    chart
    chartGroupings {
      field
      granularity
    }
    chartMeasures {
      aggregate
      field
    }
    chartPoints {
      group
      series
      values
    }
    lastSyncedAt
    unreadableFields
    blockKey
    unavailable
    missingFields
    pendingObjects
    chartUnavailable
    chartMissingFields
    chartPendingObjects
    showValues
    sortLegendValues
  }
`;

export const LOGISTICS_DHL_SHIPPING_SETTINGS_FIELDS = gql`
  fragment LogisticsDhlShippingSettingsFields on LogisticsDhlShippingSettings {
    shipper {
      name
      street
      postalCode
      city
    }
    returnAddress {
      name
      street
      postalCode
      city
    }
    labelPrintFormat
    returnLabelPrintFormat
    labelPrintFormats
    returnLabelPrintFormats
    missingSettings
    updatedAt
  }
`;

export const LOGISTICS_DHL_ACCOUNT_SETTINGS_FIELDS = gql`
  fragment LogisticsDhlAccountSettingsFields on LogisticsDhlAccountSettings {
    gateway
    clientId
    hasClientSecret
    username
    hasPassword
    billingNumberPaket
    billingNumberPaketInternational
    billingNumberRetoure
    returnReceiverIdAustria
    missingSettings
    updatedAt
  }
`;

export const LOGISTICS_SHIPPING_LABEL_FIELDS = gql`
  fragment LogisticsShippingLabelFields on LogisticsShippingLabel {
    id
    orderId
    product
    shipmentNumber
    returnShipmentNumber
    printFormat
    returnPrintFormat
    weightKg
    createdAt
    cancelledAt
    labelPdf
    returnLabelPdf
  }
`;
